import List from "./List";
import AddEdit from "./AddEdit";
import Import from "./Import";
import { List as CSVImports } from "./imports";

export default {
  List,
  AddEdit,
  Import,
  CSVImports
};
